import { useStaticQuery } from "gatsby";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import citiesMap from "../Map/cities-data.js";
import { format, isAfter } from "date-fns";
import Link from "../../utils/Link";
import "./style.scss";

const CheckList = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);

  return (
    <div
      className="accounts-row__wrap"
      style={{ marginBottom: "10px", marginTop: "10px" }}
    >
      <div className="card-features card-features--alt">
        {data.item.map((item) => (
          <div className="card-features__item card-features__item--highlighted">
            <div className="card-features__item-icon">
              <div className="card-features__item-icon__shape">
                <img
                  src="/images/icons/icon-check.svg"
                  alt={text(item, userLanguage)}
                />
              </div>
            </div>
            <div className="card-features__item-text">
              <p>{text(item, userLanguage)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckList;
